import { uiGameManager } from '../../../shared/scripts/EntryShared.ts';
import { PIXI } from '@colonist/pixi';
import { UICanvasConfig } from './UICanvasConfig.ts';
export class SectionView extends PIXI.Container {
    get absoluteHeight() {
        const absoluteHeight = this.getLocalBounds().top + this.height;
        return absoluteHeight;
    }
    get absoluteWidth() {
        const absoluteWidth = this.getLocalBounds().left + this.width;
        return absoluteWidth;
    }
    // PIXI.Container defines height and with as the bounds of its children.
    // this.width with 1 child: https://prntscr.com/10e3atg
    // this.width with multiple children: https://prntscr.com/10e3b54
    drawInitial(w, h) {
        this.bg = new PIXI.Graphics();
        this.bg.beginFill(0xFFFFFF);
        this.bg.drawRoundedRect(0, 0, w, h, 5);
        this.bg.endFill();
        this.bg.alpha = 0;
        this.addChild(this.bg);
    }
    setTip(title, bodyParagraphs) {
        const toolTipText = ()=>({
                title: title,
                body: bodyParagraphs
            });
        uiGameManager.toolTipController.createTip(toolTipText, this);
    }
    constructor(x, y, w, h, container, removePadding = false){
        super();
        const padding = removePadding ? 0 : UICanvasConfig.margin;
        this.x = x + padding;
        this.y = y + padding;
        const newW = w - padding * 2;
        const newH = h - padding * 2;
        this.drawInitial(newW, newH) // We need a background otherwise PIXI.Container doesn't have height or width
        ;
        if (container != undefined) container.addChild(this);
    }
}
